import { useState, useEffect } from 'react'
import { Input, Modal, Button } from 'Common/Supplyvue-ui'
import { Box, CircularProgress, Typography } from '@mui/material'
import { OperationalPlannerCloneModalPropsType } from './OperationalPlanner.types'

export const OperationalPlannerCloneModal = ({
  planName = '',
  isModalOpen = false,
  handleModalClose,
  handleCloneClick,
  isLoading,
  nameList,
}: OperationalPlannerCloneModalPropsType) => {
  const [newPlannerName, setNewPlannerName] = useState('')
  const [isNameAlreadyTaken, setIsNameAlreadyTaken] = useState(false)

  useEffect(() => {
    setNewPlannerName(planName)
  }, [planName])

  useEffect(() => {
    const found = nameList.find((name: string) => name === newPlannerName)
    if (found) {
      setIsNameAlreadyTaken(true)
    } else {
      setIsNameAlreadyTaken(false)
    }
  }, [newPlannerName, nameList])

  const handlePlanNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewPlannerName(event.target.value)
  }

  const Body = (
    <Box width="480px">
      <Box marginBottom="5px">
        <Typography variant="h4">New clone plan name</Typography>
      </Box>

      <Input
        fullWidth
        value={newPlannerName}
        onChange={handlePlanNameChange}
        ariaLabel="Clone plan"
      />
      <Box marginTop={3} color="red">
        {isNameAlreadyTaken && (
          <Typography variant="h4">
            This name is already taken, please try a new name.
          </Typography>
        )}
      </Box>
    </Box>
  )
  const Footer = (
    <Box>
      <Button
        variant="outlined"
        onClick={handleModalClose}
        sx={{
          marginLeft: '20px',
          minWidth: '105px',
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={
          newPlannerName === '' ||
          newPlannerName === planName ||
          isNameAlreadyTaken
        }
        onClick={() => handleCloneClick(newPlannerName)}
        sx={{
          marginLeft: '20px',
          minWidth: '105px',
        }}
      >
        {isLoading && (
          <CircularProgress
            color="inherit"
            size={16}
            sx={{
              marginRight: '8px',
            }}
          />
        )}
        Clone
      </Button>
    </Box>
  )
  return (
    <Modal
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return
        }
        // Handle other close events
        handleModalClose()
      }}
      aria-labelledby="Clone plan"
      open={isModalOpen}
      handleClose={handleModalClose}
      header="Clone plan"
      body={Body}
      footer={Footer}
    />
  )
}
